import React from "react";
import { Routes, Route } from "react-router-dom";
import ListLead from "../Components/Leads/listLead";
import ViewLead from "../Components/Leads/viewLead";
import AddAppointment from "../Components/Leads/createAppointment";

const LeadRoutes = () => {
  return (
    <Routes>
      <Route
        path="/leads"
        element={<ListLead />}
      />
      <Route
        path="/leads/view/:id"
        element={<ViewLead />}
      />
      <Route
        path="/leads/create_appointment/:id"
        element={<AddAppointment />}
      />
    </Routes>
  );
};

export default LeadRoutes;